import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { CreatorsVerticalName } from './CreatorsVerticalName.jsx';

import styles from './styles/CreatorsTopCreator.scss';

function CreatorsTopCreatorComponent({ position, topCreator, vertical }) {
    const dataTn = `top-creator-${position}`;
    return (
        <li className={styles.item} data-tn={dataTn}>
            <Link href={topCreator.url} className={styles.link}>
                <img alt={topCreator.name} src={topCreator.image} className={styles.image} />
                <div className={styles.info}>
                    <span className={styles.name}>{topCreator.name}</span>
                    <span className={styles.vertical}>
                        <CreatorsVerticalName vertical={vertical} />
                    </span>
                </div>
            </Link>
        </li>
    );
}

CreatorsTopCreatorComponent.propTypes = {
    vertical: PropTypes.string.isRequired,
    topCreator: PropTypes.object.isRequired,
    position: PropTypes.number,
};

export const CreatorsTopCreator = createFragmentContainer(CreatorsTopCreatorComponent, {
    topCreator: graphql`
        fragment CreatorsTopCreator_topCreator on TopCreator {
            image
            name
            url
        }
    `,
});
